import { ReactNode, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

export type HeaderPortalProps = {
  children: ReactNode;
  className?: string;
};
export const HeaderPortal = ({ children }: HeaderPortalProps) => {
  const targetRef = useRef(document.getElementById('header-portal'));

  useEffect(() => {
    targetRef.current = document.getElementById('header-portal');
  }, []);

  const el = targetRef.current || (targetRef.current = document.getElementById('header-portal'));
  return <>{el && createPortal(children, el)}</>;
};
